import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *文案成果列表
 * @param params
 * 
*/

export const resultList = params => Http.get(`${baseUrl}/sz/team/wa`, { params })

/**
 *文案详情
 * @param waId
 * 
*/

export const info = waId => Http.get(`${baseUrl}/sz/team/wa/${waId}`)
